import { render, staticRenderFns } from "./product-detail-show.vue?vue&type=template&id=0dea35c3&scoped=true&"
import script from "./product-detail-show.vue?vue&type=script&lang=js&"
export * from "./product-detail-show.vue?vue&type=script&lang=js&"
import style0 from "./product-detail-show.vue?vue&type=style&index=0&id=0dea35c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dea35c3",
  null
  
)

export default component.exports